import { createCleanupCallback20ojlqmkr3oia as createCleanupCallback } from '../internal/createCleanupCallback.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function invoke(_this__u8e3s4, effect, dependencies) {
  var callback = createCleanupCallback(effect);
  _this__u8e3s4(callback, dependencies);
}
function invoke_0(_this__u8e3s4, effect) {
  var callback = createCleanupCallback(effect);
  _this__u8e3s4(callback);
}
//region block: exports
export {
  invoke as invokechk3lkgbyxfd,
  invoke_0 as invoke1ef51ay3uv4ui,
};
//endregion

//# sourceMappingURL=EffectHook.mjs.map
